<script>
export default {
    methods: {
        getGridItem: function() {
            return this.$store.state.gridItems[this.gridItemIndex].data;
        },
        postUpdate: function(event, cellStateUnchanged) {
            this.$store.commit('updateGridItem', [this.gridItemIndex, this.tag, event]);

            axios.post(this.route , {
                brand_id: this.brandId,
                country_id: this.countryId,
                tag: this.tag,
                value: event,
                reset: cellStateUnchanged
            })
                .then(response => {
                    this.$root.$data.enableCommit = !!response.data;
                });
        },
        focusNextCell: function() {
            let element = this.selectNextCell();

            if (element) {
                element.focus();
            }
        },
        selectNextCell: function () {
            let nextControl = this.$el;
            if ( ! nextControl) {
                return null;
            }

            // Select the next contol and loop on if control is disabled
            do {
                nextControl = this.selectNextControl(nextControl);
            } while (nextControl && nextControl.getAttribute("disabled"));

            return nextControl;
        },
        selectNextControl: function (element) {
            // From here we need to work up to the <td> element
            do {
                element = element.parentElement;
            } while (element && element.tagName.toLowerCase() != 'td');

            // Now move to the next sibling
            // If there is a next sibling it will be the next <td> so we need to go down a level into the cell contents
            // Otherwise we'll need to go to the next row
            if (element.nextElementSibling) {
                element = element.nextElementSibling.firstElementChild;
            } else {
                // If there is a next row set it and drill into the first <td> and control
                if (element.parentElement.nextElementSibling) {
                    element = element.parentElement.nextElementSibling.firstElementChild.firstElementChild;
                } else {
                    return null;
                }
            }

            // Now drill down to find the form element
            return this.recurseSelectNextControl(element);
        },

        recurseSelectNextControl: function (element) {
            // Return element if it is a form control
            if (element.classList && (element.classList.contains('form-control') || element.classList.contains('custom-select'))) {
                return element;
            }
            // Otherwise check the children
            for (let index = 0; index < element.childNodes.length; index++) {
                element = element.childNodes[index];
                if (element.classList && (element.classList.contains('form-control') || element.classList.contains('custom-select'))) {
                    return element;
                }
            }
        },

    },
}
</script>
